export const apiBase =
  (window as Window & {TAX_ASSISTANT_API_BASE?: string}).TAX_ASSISTANT_API_BASE ||
  // www.xiaostorm.com already reverse-proxies /api to the Node service.
  // Keeping production requests same-origin avoids depending on an
  // independently managed API certificate or cross-origin session cookie.
  '';

export function apiUrl(path: string): string {
  const build = (window as Window & {__TAX_ASSISTANT_BUILD__?: string}).__TAX_ASSISTANT_BUILD__;
  const cacheBust = `__api_build=${encodeURIComponent(build || Date.now())}`;
  return `${apiBase}${path}${path.includes('?') ? '&' : '?'}${cacheBust}`;
}

/**
 * 返回静态资源地址
 * @param path assets 目录下的相对路径
 */
export function assetUrl(path: string): string {
  const build = (window as Window & {__TAX_ASSISTANT_BUILD__?: string}).__TAX_ASSISTANT_BUILD__;
  const normalized = path.replace(/^\/+/, '');
  return `/assets/${normalized}${normalized.includes('?') ? '&' : '?'}v=${encodeURIComponent(build || '')}`;
}
